import type { RExternalAppDetails } from 'v2/types/api/settings'
import { INTEGRATION_AUTH_TYPES } from '../utils/constants'

// Never empty: a blank second line on a catalog row reads as a loading state.
export const resolveAppDescription = (app: RExternalAppDetails): string =>
  app.description?.trim() || INTEGRATION_AUTH_TYPES[app.oauth_type] || 'Other'
